import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import HeroCarousel from '@/pages/home/components/HeroCarousel';
import CategoryEntries from '@/pages/home/components/CategoryEntries';
import LatestSection from '@/pages/home/components/LatestSection';
import FeaturedSection from '@/pages/home/components/FeaturedSection';
import TopicSection from '@/pages/home/components/TopicSection';
import HotRanking from '@/pages/home/components/HotRanking';
import { usePageMeta } from '@/hooks/usePageMeta';
import { mediaList } from '@/mocks/movies';
import { typeLabel } from '@/utils/media';

export default function Home() {
  const { t } = useTranslation();

  usePageMeta(
    '久久久精品-优质影视资源聚合平台',
    '久久久精品提供丰富的影视资源，包括电影、电视剧和综艺等多类别内容，满足用户多样化观影需求，带来便捷的影视内容浏览体验。',
    '久久久精品,影视资源,电影推荐,电视剧精选,影视聚合,影片播放,影视平台',
  );

  const marquee = [...mediaList].sort((a, b) => b.heat - a.heat).slice(0, 10);

  return (
    <div className="jjj-fade-up">
      <HeroCarousel />

      <div className="border-b border-background-200 bg-primary-950">
        <div className="mx-auto flex h-11 max-w-page items-center gap-3 overflow-hidden px-4 md:px-6">
          <span className="flex shrink-0 items-center gap-1.5 text-xs font-semibold text-accent-400">
            <i className="ri-flashlight-fill"></i>
            正在热播
          </span>
          <div className="relative flex-1 overflow-hidden">
            <div className="jjj-marquee flex w-max items-center gap-6 whitespace-nowrap">
              {[...marquee, ...marquee].map((item, i) => (
                <span key={`${item.id}-${i}`} className="text-xs text-background-200/80">
                  {item.title}
                  <span className="ml-1.5 text-accent-400">· {typeLabel(item.type)}</span>
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>

      <CategoryEntries />
      <LatestSection />
      <FeaturedSection />
      <TopicSection />
      <HotRanking />

      <section className="mx-auto max-w-page px-4 pb-4 md:px-6">
        <div className="rounded-lg bg-gradient-to-r from-primary-600 to-primary-500 px-6 py-10 text-center md:px-10 md:py-14">
          <h2 className="font-heading text-xl font-bold text-background-50 md:text-2xl">{t('aboutTitle')}</h2>
          <p className="mx-auto mt-3 max-w-2xl text-sm text-background-100/85">{t('aboutLead')}</p>
          <div className="mt-6 flex flex-wrap justify-center gap-3">
            <Link
              to="/about"
              className="inline-flex items-center gap-2 rounded-md bg-accent-500 px-5 py-2.5 text-sm font-semibold text-accent-950 transition hover:bg-accent-400 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-information-line text-lg"></i>
              {t('navAbout')}
            </Link>
            <Link
              to="/search"
              className="inline-flex items-center gap-2 rounded-md border border-background-50/40 px-5 py-2.5 text-sm font-semibold text-background-50 transition hover:bg-background-50/10 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-search-line text-lg"></i>
              {t('navSearch')}
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}